import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ToastProvider } from '../components/ui/toast'
import '../index.css'
import { queryClient } from '../lib/api'
import { ThemeProvider } from '../theme/ThemeContext'
import { applyTrodoPrimaryCssVars } from '../theme/trodoColors'
import AdminApp from './AdminApp'

applyTrodoPrimaryCssVars()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <BrowserRouter>
            <AdminApp />
          </BrowserRouter>
        </ToastProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
)
